import { IsBoolean, IsNumber, IsOptional } from 'class-validator';

export class AutoTopUpSettings {
  @IsBoolean()
  @IsOptional()
  autoTopUpEnabled?: boolean;

  @IsNumber()
  @IsOptional()
  autoTopUpBalance?: number;

  @IsBoolean()
  @IsOptional()
  autoTopUpToTableMax?: boolean;
}

export interface AutoTopUpSettingsDto {
  autoTopUpEnabled: boolean;
  autoTopUpBalance: number;
  autoTopUpToTableMax: boolean;
}
